'use strict'

import { addDays, addMonths, endOfMonth, format, startOfMonth, subMonths, isAfter, isSameMonth } from 'date-fns';
import { loadComponent } from './utils/load-component';
import zonedDate from '../utils/zoned-date';

const now = zonedDate();
const todayString = format(now, 'yyyy-MM-dd');

loadComponent(
    'date-picker',
    {
        props: [],
        data: function () {
            return {
                currentDate: now,
                availableDates: [],
                ViewModel: {
                    Month: null,
                    selectedDate: null
                },
            };
        },

        beforeMount: function () {
            this.$root.$on('DatePicker.updateCalendarDates', this.updateCalendarDates);
        },

        mounted: function () {
            this.generateMonth(this.currentDate);
        },

        computed: {
            showPreviousMonthButton: function () {
                return !isSameMonth(this.currentDate, now) && isAfter(this.currentDate, now);
            },
            showNextMonthButton: function () {
                if (this.availableDates.length === 0) {
                    return true;
                }

                const currentMonthEnd = endOfMonth(this.currentDate);
                return this.availableDates.some(dateString => {
                    const date = new Date(dateString);
                    return isAfter(date, currentMonthEnd);
                });
            }
        },

        methods: {
            dateClicked: function (day) {
                if (day.Date) {
                    this.ViewModel.selectedDate = day.Date;

                    this.$root.$emit('DatePicker.selectedDate', day.Date);

                    //this.generateMonth(this.currentDate);
                }
            },

            updateCalendarDates: function (newDates) {
                this.availableDates = newDates || [];
                this.generateMonth(this.currentDate);
            },

            previousMonth: function () {
                this.currentDate = subMonths(this.currentDate, 1);
                this.generateMonth(this.currentDate);
            },

            nextMonth: function () {
                this.currentDate = addMonths(this.currentDate, 1);
                this.generateMonth(this.currentDate);
            },

            generateMonth: function (date) {
                const monthStart = startOfMonth(date);
                const monthEnd = endOfMonth(date);

                let monthPadding = monthStart.getDay();

                const month = {
                    Year: format(date, 'yyyy'),
                    Month: format(date, 'MMMM'),
                    IsCurrentYear: format(date, 'yyyy') === format(now, 'yyyy'),
                    Days: Array.apply(null, Array(monthPadding)).map(() => ({})),
                };

                let testDate = monthStart;
                while (testDate <= monthEnd) {
                    const dateString = format(testDate, 'yyyy-MM-dd');
                    const day = {
                        Day: format(testDate, 'd'),
                        Today: dateString === todayString,
                        Date: dateString,
                        Events: this.availableDates.indexOf(dateString) > -1,
                        Enabled: this.availableDates.length === 0 || this.availableDates.indexOf(dateString) > -1,
                        Selected: dateString === this.ViewModel.selectedDate
                    };
                    month.Days.push(day);
                    testDate = addDays(testDate, 1);
                }

                this.ViewModel.Month = month;
            }
        },
    }
)
